// extracted by mini-css-extract-plugin
export var tosLink = "_58-0";